const ProjectConstants = {
    COMPANY_NAME: "Berliner Rechtshilfefonds Jugendhilfe e. V.",
    COMPANY_NAME_SHORT: "BRJ e. V.",
    COMPANY_MAIL: "info@brj-berlin.de",
    PROJECT_NAME: "Externe Beschwerdestelle UEBS",
    PROJECT_NAME_SHORT: "UEBS",
	COLORS : {
	  error: 'var(--red-500)',
	  warning: 'var(--yellow-500)',
	  ok: 'var(--green-500)',
	},
	NUMBER_AFFECTED : [
        { name: 'Ausschließlich ich', code: 1 },
        { name: '2', code: 2 },
        { name: '3', code: 3 },
        { name: '4', code: 4 },
        { name: '5', code: 5 },
        { name: 'mehr als 5', code: 999 }
    ],
	ROLES : [
        { name: 'Employee', code: 'employee' },
        { name: 'Boss', code: 'boss' },
        { name: 'Admin', code: 'admin' }
    ],
	INITIAL_CONTACT : [
        { name: 'Website', code: 'WEB' },
        { name: 'Telephone', code: 'TEL' },
        { name: 'Mail', code: 'MAI' },
        { name: 'Personal', code: 'PER' },
        { name: 'Letter', code: 'LET' },
        { name: 'Messenger', code: 'MES' },
        { name: 'App', code: 'APP' }
    ],
	PROCESSING_STATUSES : [
        { name: 'unedited', code: 0, customClass: 'danger' },
        { name: 'in progress', code: 1, customClass: 'info' },
        { name: 'closed', code: 2, customClass: 'success' },
        { name: 'test', code: 255, customClass: 'dark' }
    ],
    PASSWORD_CHECK: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\-\_@#\$%\^&\*\,\.])(?=.{10,})/,
    MAX_UPLOAD_SIZE: 10485760 /* if this is changed, change also server/api/config.php/max_size_all_files */,
	SELECT_COLOR_STYLES : {
    control: base => ({
      ...base,
      '&:hover, &:focus-within': {
        borderColor: 'var(--vz-primary)',
        boxShadow: '0 0 0 1px var(--vz-primary)'
      },
      borderColor: "var(--vz-input-border-custom)",
    }),
    option: (styles, { provided, data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "var(--vz-primary)" : isDisabled ? "var(--vz-gray)" : null,
        color: (isFocused || isDisabled) ? "var(--vz-white)" : data.customClass ? "var(--vz-"+data.customClass+")" : "var(--vz-black)",
        cursor: isDisabled ? 'default' : 'pointer',
      };
    }
  }
};
export default ProjectConstants;